import { GroupInput } from '@/components/v2/group-input'
import { toOptions } from '@/utils'
import { useFormikContext } from 'formik'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import CustomSelect from '@/shared/components/custom-select'
import { useGetServiceTypesQuery } from '@/store/services/service-type.service'
import { CompanySizeSelector } from '@/shared/selectors'
import { Textarea } from '@material-tailwind/react'

export const CommercialInformationForm = () => {
  const { t } = useTranslation()
  const { data: serviceTypes = [], isLoading: isLoadingServiceTypes } = useGetServiceTypesQuery()
  const {
    setFieldValue,
    values
  } = useFormikContext()

  const serviceTypeOptions = useMemo(() => {
    return toOptions({ data: serviceTypes })
  }, [serviceTypes])

  const ControlOptions = [
    { label: 'Contratista', value: 'contractor' },
    { label: 'Servicio Esporádico', value: 'sporadic_service' }
  ]

  return (
    <GroupInput
      title='Información comercial'
      description='Rellena la información de la empresa contratista.'
      className='py-8'
      divider={false}
    >
      <div className='grid grid-cols-2 gap-4'>
        {serviceTypeOptions.length > 0 && (
          <CustomSelect
            isMulti
            required
            placeholder={t('common.serviceType')}
            options={serviceTypeOptions}
            value={
              serviceTypeOptions.filter(option =>
                values.company_service_types?.some(
                  (cst) =>
                    cst.account_service_type_id === option.value && !cst._destroy
                )
              )
            }
            isLoading={isLoadingServiceTypes}
            onChange={(selectedOptions) => {
              const selectedIds = selectedOptions.map(({ value }) => value)

              const prevItems = values.company_service_types ?? []

              const newItems = selectedIds.map((id) => {
                const existing = prevItems.find(
                  (item) => item.account_service_type_id === id && !item._destroy
                )
                return existing ?? { account_service_type_id: id }
              })

              const removedItems = prevItems.filter(
                (item) => !selectedIds.includes(item.account_service_type_id)
              )

              const markedForDestroy = removedItems
                .filter((item) => item.company_service_type_id)
                .map((item) => ({ ...item, _destroy: true }))

              setFieldValue('company_service_types', [...newItems, ...markedForDestroy])
            }}
          />
        )}

        <CompanySizeSelector
          required
          value={values.size}
          onChange={({ value }) => setFieldValue('size', value)}
        />

        <CustomSelect
          required={false}
          placeholder='Tipo de control en APS'
          options={ControlOptions}
          value={ControlOptions.find(({ value }) => value === values.control_type)}
          onChange={({ value }) => setFieldValue('control_type', value)}
        />
      </div>

      <div className='mt-6'>
        <Textarea
          label='Otros contactos'
          rows={3}
          value={values.other_contacts || ''}
          onChange={(e) => setFieldValue('other_contacts', e.target.value)}
        />
      </div>
    </GroupInput>
  )
} 